import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductService } from 'src/app/service/product.service';
import { Product } from 'src/app/types/types';

@Component({
  selector: 'app-show-category',
  templateUrl: './show-category.component.html',
  styleUrls: ['./show-category.component.css']
})
export class ShowCategoryComponent implements OnInit {
  categoryName: string;
  products: Product[];

  constructor(
    private activateRouter : ActivatedRoute,
    private productService : ProductService,
    ) {
    activateRouter.params.subscribe(data => this.categoryName = data.category)
   }
   get nameOfTheSection() {
     return this.categoryName;
   }

  ngOnInit(): void {
    this.products = this.productService.getProductsFromCategory(this.categoryName);
  }

}
